<template>
	<div class="con">
		<div class="head">
			<div class="head-left">
				<img src="@/assets/doctor.png" v-if="docUser.HEADPORTRAITURL == '' || docUser.HEADPORTRAITURL == undefined" />
				<img :src="docUser.HEADPORTRAITURL" alt="" v-else />
				<div class="userDetalis">
					<div class="username">{{docUser.YGXM}}</div>
					<div class="user-disp">
						<div class="usertype">{{docUser.JBMC}}</div>
					</div>
				</div>
			</div>
			<div class="head-right">
				<div class="xingxing" @click="onCollection">
					<img :src="xing == false ? xingshow : xinghide " />
					<div class="code-text" v-if="xing == false">收藏医生</div>
					<div class="code-text-active" v-else>已收藏</div>
				</div>
				<div class="xingxing" @click="Consulting">
					<van-icon name="chat-o" size="30" />
					<div class="code-text">咨询</div>
				</div>
				<div @click="registeredBtn">
					<van-icon name="flag-o"  size="30" />
					<div class="code-text">挂号</div>
				</div>
			</div>
		</div>
		<div class="list">
			<div>
				<div class="introduce">信息</div>
				<div class="nav-right-title">
					擅长
				</div>
				<div class="nav-right-text" v-if="docUser.goodAt">
					{{docUser.goodAt}}
				</div>
				<div class="nav-right-text" v-else>
					暂无相关信息
				</div>
				<div class="nav-right-title">
					介绍
				</div>

				<div class="nav-right-text" v-if="docUser.remark">
					{{docUser.remark}}
				</div>
				<div class="nav-right-text" v-else>
					暂无相关信息
				</div>
			</div>
			<div class="discuss">
				<div v-for="(item, index) in discussList" :key='index' class="discuss-disp">
					<img class="discuss-img" src="../assets/charUser.png">
					<div class="discuss-rignt">
						<div class="wecha-name">{{item.wechaName}}</div>
						<div class="create-time">{{item.createDate}}</div>
						<div class="xing-list">
							<div v-for="(it,cell) in item.evalue" :key="cell">
								<van-icon name="star" class="xingColor" size="20" />
							</div>
						</div>
						<div class="remarks-text">{{item.remarks}}</div>
					</div>
				</div>
			</div>
		</div>
		
		<div class="comments" @click="commentsBtn">评论</div>
	</div>
</template>

<script>
	export default {
		name: 'collectionDeta',
		data() {
			return {
				msg: '通讯录详情',
				docUser: {},
				xing: false,
				xingshow: require('@/assets/stars-1.png'),
				xinghide: require('@/assets/stars.png'),
				cardUserInfo: JSON.parse(localStorage.getItem('cardUserInfo')),
				discussList: [],
			}
		},
		methods: {
			//收藏医生
			onCollection() {
				this.$store.commit('Load', true)
				this.$Axios.Post('/collect/collectDoctor?ygdm=' + this.docUser.YGDM + '&brid=' + this.cardUserInfo.brid + '&bahm=' + this.cardUserInfo.bahm + '&ksdm=' + this.docUser.KSDM + '&mzks=' + this.docUser.MZKS, null).then(
					res => {
						console.log(res)
						this.$store.commit('Load', false)
						if (res.data.code == 0) {
							if (res.data.COLLECT_STATE == 1) {
								this.$toast.success('收藏成功')
								this.xing = !this.xing;
							} else {
								this.$toast.success('取消成功')
								this.xing = !this.xing;
							}
						} else {
							this.$toast('请检查网络')
						}
					}).catch(err => {
					this.$store.commit('Load', false)
					console.log(err)
					
				})
			},
			//评论列表
			GetCommentsList(){
				this.$Axios.Get('/collect/getProposal?ysdm=' + this.docUser.YGDM + '&tepy=' + 1 + '&wechatId=' + this.cardUserInfo.wechatId + '&page=1'+'&limit=50', null).then(
					res => {
						console.log(res)
						this.$store.commit('Load', false)
						if (res.code == 0) {
							this.discussList = res.msg.list;
						} else {
							this.$toast('请检查网络')
						}
					}).catch(err => {
					this.$store.commit('Load', false)
					console.log(err)
				})
			},
			//咨询聊天
			Consulting() {
				this.$router.push({
					path: '/chatRoom',
					query: {
						doctor: JSON.stringify(this.docUser)
					}
				})
			},
			//挂号
			registeredBtn(){
				this.$router.push({
					path: '/collectionRegistered',
					query: {
						doctor: JSON.stringify(this.docUser)
					}
				})
			},
			//评论
			commentsBtn(){
				this.$router.push({
					path: '/collectionScore',
					query: {
						doctor: JSON.stringify(this.docUser)
					}
				})
			},
		},
		mounted() {
			console.log(this.cardUserInfo)
			this.docUser = JSON.parse(this.$route.query.list);
			console.log(this.docUser)
			if (this.docUser.COLLECT_STATE == 1) {
				this.xing = true;
			} else {
				this.xing = false;
			}
			this.GetCommentsList()
		},
		created() {},
	}
</script>

<style scoped>
	.con{
		display: flex;
		flex-direction: column;
		height: 100%;
	}
	.head {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 15px;
		background-color: #fff;
	}

	.head-left {
		display: flex;
		align-items: center;
	}

	.head-left img {
		margin-right: 10px;
		width: 60px;
		height: 60px;
	}

	.username {
		color: #000000;
		font-size: 15px;
	}

	.usertype {
		margin: 0 5px;
		color: #666;
	}

	.user-disp {
		margin-top: 10px;
		display: flex;
		align-items: center;
		justify-content: space-around;
		font-size: 13px;
	}

	.head-right {
		display: flex;
		text-align: center;
	}

	.xingxing {
		margin-right: 16px;
	}

	.head-right img,
	.xingxing img {
		width: 30px;
		height: 30px;
	}

	.code-text {
		margin-top: 5px;
		font-size: 14px;
	}

	.code-text-active {
		margin-top: 5px;
		font-size: 14px;
		color: #F4EA2A;
	}

	.list {
		flex: 1;
		padding: 10px;
		margin-top: 10px;
		background-color: #fff;
	}

	.introduce {
		padding: 10px 0;
		font-size: 16px;
		font-weight: 700;
		color: #000;
		background-color: #fff;
	}

	.nav-right-text {
		margin: 10px 0;
		font-size: 14px;
		color: #999;
		text-indent: 2em;
	}

	.nav-text {
		padding: 10px;
		color: #27bec4;
		border-bottom: 2px solid #27BEC4;
	}
	.comments{
		padding: 8px 0;
		width: 100%;
		background-color: #27BEC4;
		color: #fff;
		text-align: center;
		font-size: 18px;
		border-radius: 8px;
	}
	.xingColor {
		color: #F4EA2A;
	}
	.discuss{
		height: 50vh;
		overflow-y: scroll;
	}
	.discuss-disp{
		display: flex;
		padding: 5px;
		margin: 5px 0;
	}
	.discuss-img{
		width: 40px;
		height: 40px;
	}
	.discuss-rignt{
		margin-left: 10px;
	}
	.wecha-name{
		font-weight: 700;
		font-size: 14px;
		color: #000000;
	}
	.create-time{
		color: #999;
		font-size: 12px;
	}
	.xing-list{
		display: flex;
	}
	.remarks-text{
		color: #666;
		font-size: 14px;
	}
</style>
